"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocketStatus = void 0;
const domain_1 = require("@home-health-notify/domain");
const DomainContext_1 = require("../context/DomainContext");
const react_1 = require("react");
const useSocketStatus = () => {
    const { domain } = (0, react_1.useContext)(DomainContext_1.DomainContext);
    const { user } = domain;
    const socketManager = user === null || user === void 0 ? void 0 : user.getSocketManager();
    const getPerOrgStatus = (0, react_1.useCallback)(() => {
        const orgs = (user === null || user === void 0 ? void 0 : user.getActiveOrganizations()) || [];
        return orgs.map(orgUser => {
            const org = orgUser.getOrganization();
            const status = orgUser.getSocketManager().connectionStatus;
            return {
                organizationId: org.organizationId,
                organizationName: org.organizationName,
                isConnected: status.isConnected,
                isConnecting: status.isConnecting,
                retryCount: status.retryCount,
            };
        });
    }, [user]);
    const [status, setStatus] = (0, react_1.useState)(() => {
        var _a, _b;
        return ({
            aggregate: {
                isConnected: (_a = socketManager === null || socketManager === void 0 ? void 0 : socketManager.allSocketsConnected()) !== null && _a !== void 0 ? _a : false,
                isConnecting: (_b = socketManager === null || socketManager === void 0 ? void 0 : socketManager.areSocketsConnecting()) !== null && _b !== void 0 ? _b : false,
            },
            perOrg: getPerOrgStatus(),
        });
    });
    const updateStatus = (0, react_1.useCallback)(() => {
        if (socketManager) {
            setStatus({
                aggregate: {
                    isConnected: socketManager.allSocketsConnected(),
                    isConnecting: socketManager.areSocketsConnecting(),
                },
                perOrg: getPerOrgStatus(),
            });
        }
    }, [socketManager, getPerOrgStatus]);
    (0, react_1.useEffect)(() => {
        if (!socketManager)
            return;
        updateStatus();
        const unsubscribe = domain_1.Observable.getInstance().subscribe(domain_1.SocketStatusEvents.ON_CHANGE, updateStatus);
        return () => {
            unsubscribe();
        };
    }, [socketManager, updateStatus]);
    const reconnect = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (socketManager && !status.aggregate.isConnecting) {
            yield socketManager.connectSockets();
        }
    }), [socketManager, status.aggregate.isConnecting]);
    const disconnectAll = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (socketManager) {
            yield socketManager.disconnect();
        }
    }), [socketManager]);
    return {
        isConnected: status.aggregate.isConnected,
        isConnecting: status.aggregate.isConnecting,
        perOrgStatus: status.perOrg,
        reconnect,
        disconnectAll,
    };
};
exports.useSocketStatus = useSocketStatus;
